<div class="tw-flex tw-flex-col tw-gap-2">
  <h1 class="tw-font-lexend tw-font-bold tw-text-700 tw-text-gray-800" [innerHTML]="headingHtml()"></h1>
  @if (subText()) {
    <p class="tw-text-300 tw-font-body tw-text-gray-500" [innerHTML]="subTextHtml()"></p>
  }
</div>
